import { saveInLocalStorage } from '@/utils/local-storage';
import { defineStore } from 'pinia';

const initialState = {
    users: [],
    online: [],
    fetched: false,
}

export const useUserStore = defineStore('userStore', {
    state: () => initialState,

    getters: {},

    actions: {
        setUsers(value) {
            this.users = value;
            saveInLocalStorage('users', value);
        },

        setOnline(value) {
            this.online = value;
            saveInLocalStorage('online', value);
        },

        setFetched(value) {
            this.fetched = value;
        },

        clearOnlineUsers() {
            this.online = [];
            saveInLocalStorage('online', []);
        }

    }
});